<template>
<div>
  <b-container>
    <b-row>
      <b-col>
        <h2 class="text-center text-muted">
          Create Account
        </h2>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col sm="12" md="12" lg="8" class="box shadow-sm">
        <h3>
          <span class="awesome">Awesome!</span> Let's create a user for you, we are almost ready to repair your car!
        </h3>

        <input id="first_name" ref="email" v-model="input.first_name" type="text" class="frmField" placeholder="First Name">
        <input id="last_name" v-model="input.last_name" type="text" class="frmField" placeholder="Last Name">
        <input id="email" v-model="input.email" type="email" name="email" class="frmField" placeholder="Enter email address">
        <password id="password" class="Password_field" v-model="input.password" type="password" placeholder="Password" />
        <input id="retype_password" v-model="input.retype_password" type="password" class="frmField" placeholder="Retype - Password">
<b-col class="text-center">
  <p v-if="errors.length">
    <br>

      <b>Please correct the following error(s):</b>
      <span style="color: red">
        <li v-for="error in errors">{{ error }}</li>
    </span>

    </p>
</b-col>
<b-col id="matches" class="mt-2" v-if='notSamePasswords'>
<p style="color:red;">Passwords don't match.</p>
</b-col>


        <button class="btn btn-success" @click="checkForm">

        <!-- <button :disabled="!enableForm()" class="btn btn-success" @click="create"> -->
          Create Account
        </button>

      </b-col>
    </b-row>
  </b-container>

</div>
</template>

<script>
import Password from "vue-password-strength-meter";

export default {
  name: 'CreateUser',
  components: {
    Password
  },
  data() {
    return {
      errors: [],
      input: {
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        retype_password: null,
      },
      show: false
    }
  },
  created() {
    setTimeout(x => {
      this.$nextTick(() => this.setFocus()); // this works great, just watch out with going to fast !!!
    }, 1000);
  },
  mounted() {
    document.querySelector('.navbar').classList.add('darkHeader')
    if (!this.$store.state.userData.carDetails) {
      this.$router.push({
        name: 'Home',
      })
    }
  },
  computed:{
    notSamePasswords () {
    if (this.passwordsFilled) {
      return (this.input.password !== this.input.retype_password)
    } else {
      return false
    }
  },
  passwordsFilled () {
    return (this.input.password !== '' && this.input.retype_password !== '')
  },
},

  methods: {
    checkForm: function (e) {
      this.errors = [];
      if (!this.input.first_name) {
        this.errors.push("First Name required.");
      }
      if (!this.input.last_name) {
        this.errors.push("Last Name required.");
      }
      if (!this.input.password) {
        this.errors.push("Password required.");
      }
      if (!this.input.retype_password) {
        this.errors.push("Retype password required.");
      }
      if (!this.input.email) {
        this.errors.push('Email required.');
      } else if (!this.validEmail(this.input.email)) {
        this.errors.push('Valid email required.');
      }

      if (!this.errors.length) {
        this.axios
          .post(`${process.env.ROOT_API}/user/create`, {
            first_name: this.input.first_name,
            last_name: this.input.last_name,
            email: this.input.email,
            password: this.input.password,
          })
          .then(response => {
            localStorage.setItem('user-id', response.data.data.id)
            localStorage.setItem('user-token', response.data.data.token)
            this.$router.push({
              name: 'AfterSignUp'
            })
          })
          .catch(error => {
            if (error.message === 'Request failed with status code 409') {
              this.$toasted.show('User with this email already exists')
            } else {
              this.$toasted.show('An error occurred please try again')
            }
          })
      }
      e.preventDefault();
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    toggle() {
      this.show = !this.show
    },
    // create() {
      // this.axios
      //   .post(`${process.env.ROOT_API}/user/create`, {
      //     first_name: this.input.first_name,
      //     last_name: this.input.last_name,
      //     email: this.input.email,
      //     password: this.input.password,
      //   })
      //   .then(response => {
      //     localStorage.setItem('user-id', response.data.data.id)
      //     localStorage.setItem('user-token', response.data.data.token)
      //     this.$router.push({
      //       name: 'AfterSignUp'
      //     })
      //   })
      //   .catch(error => {
      //     if (error.message === 'Request failed with status code 409') {
      //       this.$toasted.show('User with this email already exists')
      //     } else {
      //       this.$toasted.show('An error occurred please try again')
      //     }
      //   })
    // },
    setFocus() {
                 this.$refs.email.focus();
            },
    enableForm() {
      if (!this.input.first_name || !this.input.last_name) {
        return false
      }
      if (!this.input.email || !this.input.password || !this.input.retype_password) {
        return false
      }
      if (this.input.password !== this.input.retype_password) {
        return false
      }
      return true
    },
  },
}
</script>

<style scoped>
.container {
  margin-top: 6rem;
  margin-bottom: 6rem;
}

.box {
  padding: 2rem;
  border-top: 3px solid #40c991;
  text-align: center;
}

.frmField {
  background-color: white;
  color: #495057;
  line-height: 1.25;
  font-size: 16px;
  font-family: 'Roboto', sans-serif;
  border: 0;
  padding: 10px;
  border: 1px solid #dbdbdb;
  border-radius: 3px;
  width: 90%;
}

.Password_field{
  margin-top: 1.5rem;
}
select,
input {
  max-width: 400px;
  margin: 1.5rem auto 0 auto;
}

#retype_password{
  margin: 0 auto 0 auto;
}

select:focus,
input:focus {
  box-shadow: none;
}

.box button {
  background-color: #40c991;
  border: none;
  border-radius: 1.2rem;
  padding: 0.5rem 4rem;
  color: #fff;
  margin: 0 auto;
  display: block;
  margin-top: 3rem;
}

h3 {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  color: #7b7e7d;
}

.awesome {
  color: #40c991;
}
</style>



// WEBPACK FOOTER //
// src/pages/create_user.vue